// extracted by mini-css-extract-plugin
export default {"container":"Footer_container__VHszA","image":"Footer_image__9fLmv","row":"Footer_row__BERpu","text_box":"Footer_text_box__Kl6EQ","text_rows":"Footer_text_rows__gEToX"};